/* eslint-disable */
import { useEffect } from 'react';
import { ReactComponent as Image } from '../assets/images/easter.svg';

export default function({ show }) {
  const hide = show > 7;
  const ewq = () => {
    const el = document.getElementById('checkId');
    el.classList.remove('show');
  };
  const asd = () => {
    const el = document.getElementById('octo');
    el.classList.add('move');
    setTimeout(ewq, 2000);
  };
  useEffect(() => {
    if (show === 7) {
      setTimeout(asd, 1000);
    }
  }, [show]);
  return (
    <div id="checkId" className={hide ? 'octo show' : 'octo'}>
      <Image id="octo" />
    </div>
  );
}
